// extracted by mini-css-extract-plugin
module.exports = {"navItem":"nav-item_navItem__T2B9G"};